function required() { // 必填
  return {
    validator: (rule, value, callback) => {
      let reg = /^\s*$/g
      if (reg.test(value) || value == undefined) {
        callback(new Error('此项必填'))
      } else {
        callback()
      }
    },
    trigger: 'blur'
  }
}

function formatPwd(message) { // 密码为8-18位，包含大小写、数字和符号
  return {
    validator: (rule, value, callback) => {
      let reg = /^.*(?=.{8,18})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@_\-#$%^&*?\\]).*$/
      if (!reg.test(value)) {
        callback(new Error(message))
      } else {
        callback()
      }
    },
    trigger: 'blur'
  }
}

function mobile() { //移动手机号
  return {
    validator: (rule, value, callback) => {
      if (value === '') {
        callback();
      } else {
        let reg = /^1\d{10}$/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      }
    },
    trigger: 'blur'
  }
}

function cardCode() { //身份证号码
  return {
    validator: (rule, value, callback) => {
      if (value === '') {
        callback();
      } else {
        let reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的身份证号'));
        } else {
          callback();
        }
      }
    },
    trigger: 'blur'
  }
}

export default {
  required, // 必填
  formatPwd, // 密码格式
  mobile, //是否为身份证号码
  cardCode //是否为移动手机号
}



// WEBPACK FOOTER //
// ./src/rule/index.js